module.exports = __webpack_public_path__ + "static/media/29-hill.aa8191f2.jpg";